module.exports = __webpack_public_path__ + "img/depmap_svg_V20.117ad284.svg";